import { useCallback, useState } from 'react';
import ArrowIcon from '../../assets/icons/arrow_right';
import he from 'he';

import style from './style.module.scss';

export const SubMenu = ({ menuItem, ...props }) => {
    const [currentItem, setCurrentItem] = useState(menuItem);

    const handleHover = useCallback(
        (item) => {
            if (!item.image_menu || item.ID === currentItem.ID) return;
            setCurrentItem(item);
        },
        [currentItem],
    );

    return (
        <div className={style.submenu} {...props}>
            <ul className={style.content}>
                {menuItem.children.map((subItem) => {
                    if (subItem.children?.length > 0) {
                        return (
                            <li
                                className={style.itemList}
                                key={subItem.ID}
                                onMouseEnter={() => handleHover(subItem)}
                                // onMouseLeave={() => handleHover(menuItem)}
                            >
                                {subItem.url && subItem.url !== '#' ? (
                                    <a href={subItem.url} className={style.name}>
                                        {he.decode(subItem.title)}
                                    </a>
                                ) : (
                                    <span className={style.name}>{he.decode(subItem.title)}</span>
                                )}
                                <ul>
                                    {subItem.children.map((subItem2) => (
                                        <li
                                            className={style.subItem}
                                            key={subItem2.ID}
                                            onMouseEnter={() => handleHover(subItem2)}
                                        >
                                            <a href={subItem2.url}>{he.decode(subItem2.title)}</a>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        );
                    } else {
                        return (
                            <li className={style.item} key={subItem.ID}>
                                <a href={subItem.url}>
                                    {he.decode(subItem.title)}
                                    <ArrowIcon />
                                </a>
                            </li>
                        );
                    }
                })}
            </ul>
            {currentItem.image_menu && (
                <div className={style.thumbnail}>
                    <img key={currentItem.ID} src={currentItem.image_menu} alt={currentItem.title} />
                </div>
            )}
        </div>
    );
};
